// src/components/categories_list/CategoriesSkeleton.tsx
import { Skeleton } from 'antd';

const CategoriesSkeleton: React.FC = () => {
    return (
        <div>
            {Array.from({ length: 12 }).map((_, index) => (
                <div key={index} className="flex items-center gap-2 mb-4">
                    <Skeleton.Avatar active size="large" shape="circle" />
                    <Skeleton.Input active size="large" style={{ width: 200 }} />
                </div>
            ))}
        </div>
    );
};

export default CategoriesSkeleton;